import { styled } from "@linaria/react"
import { observer } from "mobx-react-lite"

import { MessageAuthorName } from "@/components/Chat/MessageStyles.ts"
import { UserMessageUnknownAuthor } from "@/components/Chat/UserMessageStyles.ts"
import { EllipsisContainer } from "@/components/Ellipsis/Ellipsis.ts"
import { Horizontal } from "@/components/Flex.ts"
import { Tooltip } from "@/components/Tooltip/Tooltip.tsx"
import { getFullName } from "@/hooks/useProfile.ts"
import { formatDateTime } from "@/lib/date.ts"
import { Navigator } from "@/routes/Navigator.ts"
import { useCurrentOrgId } from "@/routes/projects/projectHooks.ts"

import type { ChatMessageModel } from "@/components/Chat/ChatModel.ts"


export const UserMessageTopLine = observer(({ message }: {
  message: ChatMessageModel
}) => {
  const orgId = useCurrentOrgId()

  const { user } = message
  const isMyMessage = message.isMyMessage

  return (
    <Container>
      {!isMyMessage && (
        <Tooltip content={formatDateTime(parseInt(message.timestamp, 10))}>
          <EllipsisContainer>
            {user ? (
              <MessageAuthorName {...Navigator.user(orgId, user.username)} viewTransition>
                {getFullName(user)}
              </MessageAuthorName>
            ) : (
              <UserMessageUnknownAuthor>Unknown user</UserMessageUnknownAuthor>
            )}
          </EllipsisContainer>
        </Tooltip>
      )}
    </Container>
  )
})

export const Container = styled(Horizontal)`
  align-items: center;
  justify-content: space-between;
  gap: 4px;

  &:empty {
    display: none;
  }
`